import { useEffect, useState } from "react";

const navLinks = [
  { label: "首页", href: "#home" },
  { label: "热门榜单", href: "#rank" },
  { label: "霸榜作品", href: "#top" },
  { label: "追更进度", href: "#updates" },
  { label: "周更作品", href: "#weekly" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur shadow-sm border-b border-background-200/80"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6 py-3 md:py-4">
        <a href="#home" className="flex items-center gap-2 whitespace-nowrap" aria-label="番木瓜漫画 首页">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-xl ${
              scrolled ? "bg-primary-500" : "bg-primary-500/90"
            } text-background-50`}
          >
            <i className="ri-empathize-line text-lg"></i>
          </span>
          <span className={`font-heading text-xl md:text-2xl ${scrolled ? "text-foreground-950" : "text-white"}`}>
            番木瓜漫画
          </span>
        </a>

        <div className="hidden items-center gap-6 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`whitespace-nowrap text-sm font-medium transition-colors ${
                scrolled ? "text-foreground-700 hover:text-primary-600" : "text-white/90 hover:text-white"
              }`}
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="hidden items-center gap-3 md:flex">
          <div
            className={`flex items-center gap-2 rounded-full px-3 py-2 ${
              scrolled ? "bg-background-100" : "bg-white/15"
            }`}
          >
            <i className={`ri-search-line text-sm ${scrolled ? "text-foreground-500" : "text-white/80"}`}></i>
            <input
              type="text"
              placeholder="搜作品 / 作者"
              className={`w-32 bg-transparent text-sm outline-none placeholder:font-label ${
                scrolled ? "text-foreground-950 placeholder:text-foreground-400" : "text-white placeholder:text-white/70"
              }`}
              aria-label="搜索漫画"
            />
          </div>
          <a
            href="#rank"
            className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            立即追更
          </a>
        </div>

        <button
          type="button"
          className={`flex h-10 w-10 items-center justify-center rounded-lg md:hidden ${
            scrolled ? "bg-background-100 text-foreground-950" : "bg-white/15 text-white"
          }`}
          onClick={() => setOpen((v) => !v)}
          aria-label="展开菜单"
          aria-expanded={open}
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200/80 bg-background-50 px-4 py-4 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
              >
                {link.label}
              </a>
            ))}
            <div className="mt-3 flex items-center gap-2 rounded-full bg-background-100 px-3 py-2">
              <i className="ri-search-line text-sm text-foreground-500"></i>
              <input
                type="text"
                placeholder="搜作品 / 作者"
                className="w-full bg-transparent text-sm text-foreground-950 outline-none"
                aria-label="搜索漫画"
              />
            </div>
            <a
              href="#rank"
              onClick={() => setOpen(false)}
              className="mt-2 rounded-full bg-primary-500 px-5 py-2.5 text-center text-sm font-semibold text-background-50"
            >
              立即追更
            </a>
          </div>
        </div>
      )}
    </header>
  );
}